import { apiDelete, apiGet, apiMultipart } from '@/services/api';
import type { UploadedAsset } from '@/services/types/UploadedAsset';

const MEDIA = '/api/v1/media';

/**
 * The media store (FR-037) — what every feature that attaches, shows or discards a file calls. It
 * was reached by URL from seven features; one module is what keeps them pointing at the same place.
 *
 * `meta` is generic because callers read different slices of the record (AttachmentMeta in the
 * cabinet, the name alone elsewhere) and each declares the fields it uses.
 */
export const mediaApi = {
  /** Multipart upload; the asset's `accessLevel` ('PUBLIC' / 'PRIVATE') is fixed at upload. */
  upload: (file: File, accessLevel: string) => {
    const form = new FormData();
    form.append('file', file);
    form.append('accessLevel', accessLevel);
    return apiMultipart<UploadedAsset>(MEDIA, form);
  },
  meta: <T>(id: string) => apiGet<T>(`${MEDIA}/${id}`),
  remove: (id: string) => apiDelete(`${MEDIA}/${id}`),
  /**
   * Where an uploaded file is served from. One of the two image paths HtmlSanitizer's IMAGE_SRC
   * allows, and a site-rooted path its LINK_HREF allows, so the same URL survives as both. A plain
   * link, not a fetch: the browser follows it with the session cookie.
   */
  downloadUrl: (id: string) => `${MEDIA}/${id}/download`,
};
